import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ant-upload-text" }, "上传", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_business_filter = _resolveComponent("business-filter")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.store.state.msgauditApply.addState,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.store.state.msgauditApply.addState = $event)),
    width: "550px",
    title: _ctx.detail ? '编辑申请记录' : '新增申请记录',
    class: "no-padding-body",
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { span: 6 },
        "wrapper-col": { span: 18 },
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "商户名称",
            name: "corpId"
          }, {
            default: _withCtx(() => [
              (_ctx.detail)
                ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.detail && _ctx.detail.corpName), 1))
                : (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode(_component_business_filter, {
                      value: _ctx.form.corpId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.corpId = $event)),
                      onSelected: _ctx.changeBusinsess
                    }, null, 8, ["value", "onSelected"])
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "手机号",
            name: "mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.mobile,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.mobile = $event)),
                placeholder: "申请人手机号"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "状态",
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.form.status,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.status = $event)),
                placeholder: "请选择状态",
                style: {"width":"300px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "申请人",
            name: "applyName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.applyName,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.applyName = $event)),
                placeholder: "请输入申请人"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "申请会话数",
            name: "applyCount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.applyCount,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.applyCount = $event)),
                placeholder: "请输入申请会话数"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "成交金额",
            name: "dealAmount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.dealAmount,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.dealAmount = $event)),
                placeholder: "请输入成交金额"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "实际开通会话数",
            name: "realOpenCount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.realOpenCount,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.realOpenCount = $event)),
                placeholder: "请输入企微实际开通会话数"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "附件",
            name: "attachments"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_upload, {
                    value: _ctx.form.attachments,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.attachments = $event)),
                    name: "avatar",
                    style: {"width":"300px"},
                    "list-type": "picture-card",
                    class: "avatar-uploader",
                    "show-upload-list": false,
                    customRequest: _ctx.customUploadRequest,
                    onChange: _ctx.handleChange
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["value", "customRequest", "onChange"])
                ]),
                _: 1
              }, 8, ["spinning"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.attachments, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  style: {"line-height":"1"},
                  key: index
                }, [
                  _createVNode("a", {
                    href: item,
                    target: "_blank"
                  }, _toDisplayString(item), 9, ["href"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.removeAttachment(index))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "备注",
            name: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.remark,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.remark = $event)),
                placeholder: "请输入备注"
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "afterClose", "onCancel"]))
}